import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { styled } from '@mui/system';

import { baseCoverSx } from 'styles/sx/coverSx';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const StyledBox = styled(Box, {
  shouldForwardProp: muiPropForwarding('ownState')
})(({ theme, ownState }) => {
  const ownCoverStyles = ownState?.cover?.(theme) ?? {};

  return {
    ...baseCoverSx,
    ...ownCoverStyles
  };
});

const Cover = ({ children, dataTestId, ownState = {}, ...rest }) => {
  return (
    <StyledBox data-testid={dataTestId} ownState={ownState} {...rest}>
      {children}
    </StyledBox>
  );
};

Cover.propTypes = {
  dataTestId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  ownState: PropTypes.object
};

export default Cover;
